var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Page } from "../../lib/page-component";
import KnockoutModel from "../../lib/knockout_model";
import '../../components/header';
import '../../components/leftMenu';
import './file.css';
import '../../lib/knockout_fileUpload';
import * as authorization from "../../lib/authorization";
import * as ajax from '../../app-lib/ajax_proxy';
import "../../components/header";
import "./fileProgressBar.css";
import * as Configs from "../../app-lib/constants";
import "../../lib/knockout_pscUpload";
import "../../lib/knockout_datafileUpload";
import '../../lib/knockout_datePicker';
import '../../lib/knockout_fileUpload';
import "../../components/paging";
//import { relativeTimeThreshold } from "moment";
// let fd = new FormData();//提交文件
var HeaderModel = /** @class */ (function (_super) {
    __extends(HeaderModel, _super);
    function HeaderModel(root) {
        var _this = _super.call(this, '/api/ice/filemap', root, { userId: authorization.getUserId() }) || this;
        _this.leadurl = ko.observable('/api/ice/upload');
        _this.folders = ko.observableArray([]); //文件夹列表数据
        _this.files = ko.observableArray(); //文件列表
        _this.saveFolderNameId = ko.observable(); //当前选择文件夹id
        _this.newFolderName = ko.observable(""); //新增的文件夹名
        _this.newFileName = ko.observable(""); //更新文件名
        _this.searchName = ko.observable(""); // 查询的文件名
        _this.editFolderName = ko.observable('');
        _this.fileId = ko.observable(); //文件夹id
        _this.folderName = ko.observable('');
        _this.popur2 = ko.observable(0);
        _this.popur4 = ko.observable(0);
        // 新增文件夹
        _this.popur = ko.observable(0);
        _this.createType = ko.observable();
        _this.deleteType = ko.observable();
        _this.downType = ko.observable();
        _this.uploadType = ko.observable();
        //userAccount=ko.observable();
        /////
        _this.domId = ko.observableArray([]);
        // 排序设置一个标识位
        _this.flag = ko.observable(0);
        // 选择左侧的框
        _this.folderJs = ko.observable();
        _this.popur3 = ko.observable(0);
        // 进度条弹框
        _this.hiddenBodyOne = ko.observable(true);
        _this.hiddenBodytwo = ko.observable(false);
        _this.fileList = ko.observableArray([]); //文件列表
        _this.fileText = ko.observable(''); //文件统计提示
        _this.hiddenBar = ko.observable(false);
        _this.hiddenWord = ko.observable(true);
        _this.hiddenWan = ko.observable(false);
        _this.stime = ko.observable(); //开始时间
        _this.etime = ko.observable(); //结束时间
        _this.localTime = ko.observable(0); //本地上传需要多久
        _this.progressBar = ko.observable(0); //进度条%
        _this.fileData = ko.observableArray(); //上传的文件的ID和name
        _this.pid = ko.observable(''); //文件柜上传id
        _this.cid = ko.observable(''); //表单上传id
        _this.fileUploadUrl = ko.observable(''); //文档上传url
        _this.fileSize = ko.observable(0); //文件大小
        _this.hiddenX = ko.observable(true); //点击删除文件
        _this.newFd = ko.observableArray(); //文件上传对象
        return _this;
    }
    HeaderModel.prototype.open = function () {
        //console.log('1')
    };
    /////////////////////////test ice
    // 文件上传调用组件
    HeaderModel.prototype.fileUpload = function () {
        window.popBox.show("/fileUploadProgressBar/fileProgressBar?pid=" + this.saveFolderNameId()).then(function (d) {
            console.log(d);
        });
    };
    ///////////////////////////////
    HeaderModel.prototype.onUploaded = function (ds, data) {
        //TODO 文件上传完成后的操作，需要修改files值，自动更新页面。
        this.data = {};
        //this.url = "/api/ice/filemap";
        this.data.fid = this.saveFolderNameId();
        this.data.userId = authorization.getUserId();
        this.loadData();
        //console.info("uploaded  fresh.....");
    };
    //////////////////////
    // 查询文件,通过后端再次取数据实现
    HeaderModel.prototype.Search2 = function () {
        var _this = this;
        // this.data = {};
        if (this.searchName().trim() == "") {
            this.id = null;
            ajax.get("/api/ice/foldermap2", { userId: authorization.getUserId() })
                .then(function (d) {
                if (d.data.folderNames.length < 1) {
                    _this.uploadType('2');
                }
                else {
                    _this.uploadType('1');
                }
                _this.folders(d.data.folderNames);
                if (d.data.folderNames.length > 0) {
                    _this.saveFolderNameId(d.data.folderNames[0].id);
                    var tr = document.getElementById(_this.saveFolderNameId()); //默认选择
                    tr.setAttribute("style", "background:#cde3f7");
                }
                if (!d.data[0]) {
                    //window.popBox.show("没有搜索到指定文件夹！");
                }
                if (d.message != '无文件夹') {
                    ajax.get('/api/ice/filemap', {
                        fid: d.data.folderNames[0].id,
                        userId: authorization.getUserId(),
                        pageIndex: 1,
                    }).then(function (d) {
                        _this.viewModel(d);
                    });
                }
                console.log(_this.viewModel(), '-----ahhahaha');
                return d.data[0] ? d.data[0] : null;
            });
        }
        else {
            this.id = null;
            ajax.get("/api/ice/foldermap2", { name: this.searchName(), userId: authorization.getUserId() })
                .then(function (d) {
                if (d.data.folderNames.length < 1) {
                    _this.uploadType('2');
                }
                else {
                    _this.uploadType('1');
                }
                _this.folders(d.data.folderNames);
                if (d.data.folderNames.length > 0) {
                    _this.saveFolderNameId(d.data.folderNames[0].id);
                    var tr = document.getElementById(_this.saveFolderNameId()); //默认选择
                    tr.setAttribute("style", "background:#cde3f7");
                }
                if (!d.data[0]) {
                    //window.popBox.show("没有搜索到指定文件夹！");
                }
                if (d.message != '无文件夹') {
                    ajax.get('/api/ice/filemap', {
                        fid: d.data.folderNames[0].id,
                        userId: authorization.getUserId(),
                        pageIndex: 1,
                    }).then(function (d) {
                        _this.viewModel(d);
                    });
                }
                console.log(_this.viewModel(), '-----ahhahaha');
                return d.data[0] ? d.data[0] : null;
            });
        }
    };
    // 时间的排序  向上的按钮
    HeaderModel.prototype.Top = function () {
        var pageIndex = this.viewModel().data.pageIndex;
        // 0  这时 是从低到高排序
        this.data = {};
        this.data.userId = authorization.getUserId();
        this.data.fid = this.saveFolderNameId();
        this.data.pageIndex = pageIndex;
        this.data.order = "up";
        //this.url="/api/ice/filemap";
        this.loadData();
    };
    // 向下的按钮
    HeaderModel.prototype.Bottom = function () {
        var pageIndex = this.viewModel().data.pageIndex;
        // 0  这时 是从低到高排序
        this.data = {};
        this.data.userId = authorization.getUserId();
        this.data.fid = this.saveFolderNameId();
        this.data.pageIndex = pageIndex;
        this.data.order = "down";
        // this.url="/api/ice/filemap";
        this.loadData();
    };
    // 新增文件夹
    HeaderModel.prototype.Add = function () {
        var _this = this;
        if (this.newFolderName().trim() == "") {
            window.popBox.show("文件夹名称不能为空！");
            return;
        }
        if (this.newFolderName().length > 10) {
            window.popBox.show("文件夹名称过长！");
            return;
        }
        // this.data={};
        // this.url = "/api/ice/createfolder";
        // this.data.name=this.newFolderName();
        // this.data.uid=window.localStorage.getItem("UserId");
        // this.id = null;
        ajax.post("/api/ice/createfolder", { name: this.newFolderName(), uid: authorization.getUserId() })
            .then(function (d) {
            if (d.status == '0') {
                ajax.get("/api/ice/foldermap2", { userId: authorization.getUserId() })
                    .then(function (d) {
                    console.log(d);
                    _this.searchName('');
                    _this.folders(d.data.folderNames);
                    _this.uploadType('1');
                    if (d.data.folderNames.length > 0) {
                        _this.saveFolderNameId(d.data.folderNames[0].id);
                        var tr = document.getElementById(_this.saveFolderNameId()); //默认选择
                        tr.setAttribute("style", "background:#cde3f7");
                    }
                    if (d.message != '无文件夹') {
                        ajax.get('/api/ice/filemap', {
                            fid: d.data.folderNames[0].id,
                            userId: authorization.getUserId(),
                            pageIndex: 1,
                        }).then(function (d) {
                            _this.viewModel(d);
                        });
                    }
                });
            }
        }).catch(function (e) {
            window.popBox.show(e.message);
        });
        this.popur(0);
    };
    HeaderModel.prototype.Select = function (e, m) {
        var _this = this;
        this.folderName(e.folderName); //记录当前选择的文件夹 
        this.saveFolderNameId(e.id); // 记录当前的文件夹id
        this.folderJs(e);
        //console.log("dddd" + this.saveFolderNameId());
        var trs = document.getElementsByClassName("file-left-center-line");
        for (var i = 0; i < trs.length; i++) {
            trs[i].setAttribute("style", "background:white");
        }
        var tr = document.getElementById(e.id);
        tr.setAttribute("style", "background:#cde3f7");
        this.data = {};
        //this.url = "/api/ice/filemap";
        this.data.fid = e.id;
        //加载选择文件夹下的文件数据 
        this.id = null;
        this.data.userId = authorization.getUserId();
        this.loadData().then(function (d) {
            _this.downType(d.data.down);
        });
    };
    //文件重命名
    HeaderModel.prototype.Edit = function (e, data) {
        var _this = this;
        var pageIndex = this.viewModel().data.pageIndex;
        //console.log(this.fileId)
        if (this.newFileName().trim() == "") {
            return window.popBox.show("文件名称不能为空！");
        }
        if (this.newFileName().length > 20) {
            return window.popBox.show("文件名称过长！");
            ;
        }
        // this.data={};
        // this.url = "/api/ice/renamefiles";
        // this.data.name=this.newFileName();
        // this.data.id=this.fileId;
        ajax.get("/api/ice/renamefiles", { id: this.fileId, name: this.newFileName() })
            .then(function (d) {
            _this.searchName('');
            window.popBox.show(d.message).then(function () {
                var tr = document.getElementById(_this.saveFolderNameId()); //默认选择
                tr.setAttribute("style", "background:#cde3f7");
                ajax.get('/api/ice/filemap', {
                    fid: _this.saveFolderNameId(),
                    userId: authorization.getUserId(),
                    pageIndex: 1,
                }).then(function (d) {
                    _this.viewModel(d);
                });
            });
        }).catch(function (e) {
            window.popBox.show(e.message);
        });
        this.popur2(0);
    };
    // 刪除文件
    HeaderModel.prototype.Delete = function (e, m) {
        var _this = this;
        if (this.deleteType() == '1') {
            var flag = confirm("是否确认删除文件?");
            if (flag) {
                // let pageIndex = this.viewModel().data.pageIndex;
                // this.data={};
                // this.url = "/api/ice/deletefiles";
                // this.data.ids=e.fileId;
                // this.data.account=window.localStorage.getItem("UserId");
                ajax.get("/api/ice/deletefiles", { ids: e.fileId, account: authorization.getUserId() })
                    .then(function (d) {
                    _this.searchName('');
                    window.popBox.show(d.message).then(function () {
                        var tr = document.getElementById(_this.saveFolderNameId()); //默认选择
                        tr.setAttribute("style", "background:#cde3f7");
                        ajax.get('/api/ice/filemap', {
                            fid: _this.saveFolderNameId(),
                            userId: authorization.getUserId(),
                            pageIndex: 1,
                        }).then(function (d) {
                            _this.viewModel(d);
                        });
                    });
                });
            }
        }
        else {
            window.popBox.show('你没有权限');
        }
    };
    //////编辑文件夹
    HeaderModel.prototype.editFolder = function () {
        var _this = this;
        // this.data = {};
        if (this.editFolderName().trim() == this.folderName().trim()) {
            this.popur3(0);
            return;
        }
        if (this.editFolderName().trim() == "") {
            window.popBox.show("文件夹名称不能为空！");
            return;
        }
        if (this.editFolderName().length > 10) {
            window.popBox.show("文件夹名称过长！");
            return;
        }
        if (this.editFolderName().trim() == "") {
        }
        else {
            ajax.put("/api/folder", { id: this.saveFolderNameId(), folderName: this.editFolderName() })
                .then(function (d) {
                ajax.get("/api/ice/foldermap2", { userId: authorization.getUserId() })
                    .then(function (d) {
                    _this.searchName('');
                    _this.folders(d.data.folderNames);
                    var tr = document.getElementById(_this.saveFolderNameId()); //默认选择
                    tr.setAttribute("style", "background:#cde3f7");
                    if (d.message != '无文件夹') {
                        ajax.get('/api/ice/filemap', {
                            fid: _this.saveFolderNameId(),
                            userId: authorization.getUserId(),
                            pageIndex: 1,
                        }).then(function (d) {
                            _this.viewModel(d);
                        });
                    }
                });
            }).catch(function (e) {
                window.popBox.show(e.message);
            });
            ;
        }
        this.popur3(0);
    };
    ///////删除文件夹
    HeaderModel.prototype.deleteFolder = function (event, id) {
        var _this = this;
        event.stopPropagation();
        if (this.deleteType() == '1') {
            //console.log("这是" + id);
            var flag = confirm("是否确认删除此文件夹");
            if (flag) {
                ajax.deleteIt("/api/folder", { id: id }).then(function (d) {
                    if (d.status == '0') {
                        ajax.get("/api/ice/foldermap2", { userId: window.localStorage.getItem("UserId") })
                            .then(function (d) {
                            _this.searchName('');
                            _this.folders(d.data.folderNames);
                            _this.saveFolderNameId(d.data.folderNames[0].id);
                            var tr = document.getElementById(d.data.folderNames[0].id); //默认选择
                            tr.setAttribute("style", "background:#cde3f7");
                            if (d.message != '无文件夹') {
                                ajax.get('/api/ice/filemap', {
                                    fid: _this.saveFolderNameId(),
                                    userId: authorization.getUserId(),
                                    pageIndex: 1,
                                }).then(function (d) {
                                    _this.viewModel(d);
                                });
                            }
                        });
                    }
                }).catch(function (e) {
                    //console.log(e);
                    window.popBox.show(e.message);
                });
            }
        }
        else {
            window.popBox.show('你没有权限');
        }
    };
    ////////////////////////////
    HeaderModel.prototype.Popur = function () {
        //console.log("1111");
        if (this.createType() == '1') {
            this.newFolderName("");
            if (this.popur() == 1) {
                this.popur(0);
            }
            else {
                this.popur(1);
            }
        }
        else {
            window.popBox.show('你没有权限');
        }
    };
    // 弹出编辑文件名框
    HeaderModel.prototype.Popur2 = function (e, data) {
        this.newFileName(e.fileName);
        this.editFileName = e.fileName;
        this.fileId = e.fileId;
        if (this.popur2() == 1) {
            this.popur2(0);
        }
        else {
            this.popur2(1);
        }
    };
    //编辑文件夹
    HeaderModel.prototype.Popur3 = function (root, m) {
        this.saveFolderNameId(m.id);
        this.editFolderName(m.folderName);
        if (this.popur3() == 1) {
            this.popur3(0);
        }
        else {
            this.popur3(1);
        }
    };
    HeaderModel.prototype.fileBar = function () {
        // console.log(this.saveFolderNameId() + '-----------------文件夹id')
        if (this.popur4() == 1) {
            this.popur4(0);
        }
        else {
            this.popur4(1);
        }
    };
    // 继续添加文件
    HeaderModel.prototype.fileChange = function (r, e) {
        this.hiddenBodyOne(false);
        this.hiddenBodytwo(true);
        this.hiddenX(true);
        // var  fd = new FormData();//提交文件
        var input = e.currentTarget;
        if ((this.fileList().length + input.files.length) > 10) {
            return window.popBox.show('一次最多上传10个文件!');
        }
        for (var i = 0; i < input.files.length; i++) {
            if (Number(input.files[i].size) > 10485760) {
                return window.popBox.show('单个文件不能超过10M');
            }
            // 判断重复文件
            for (var n = 0; n < this.fileList().length; n++) {
                if (this.fileList()[n].fileName == input.files[i].name) {
                    return window.popBox.show(input.files[i].name + '文件已存在!');
                }
            }
            if (i >= 10) {
                return window.popBox.show('一次最多上传10个文件!');
            }
            // if(fd.getAll('file'))
            this.fileList.push({ 'fileName': input.files[i].name, 'fileLength': input.files[i].size });
            this.newFd().push(input.files.item(i)); //后台使用参数名file数组来获取所有上传文件
            // let fl: number = 0;
            if (this.fileList().length > 5) {
                var fs = this.container.querySelector('.file-zs');
                fs.style.height = '40%';
            }
        }
        // 清空input狂选择的文件
        var obj = this.container.querySelector('.fileUpload-inputOne');
        var obj1 = this.container.querySelector('.fileUpload-inputTwo');
        obj1.value = '';
        obj.value = '';
        // if(this.newFd()){
        // 	// this.newFd().getItem()
        // 	for(let n=0;n<this.newFd().getAll('file').length;n++){
        // 		fd.append('file',this.newFd().getAll('file')[n]);
        // 	}
        // }
        this.fileSize(0);
        var fl = 0;
        // 删除文件后文件数量以及总大小改变
        for (var h = 0; h < this.fileList().length; h++) {
            fl = fl + Number(this.fileList()[h].fileLength);
            this.fileSize(fl / 1024);
            if (this.fileSize() > 1024) {
                this.fileSize(fl / 1048576);
                var str = '选中' + this.fileList().length + '/10 个文件，共' + this.fileSize().toFixed(2) + 'M,单个文件大小限制:10.00M。';
                this.fileText(str);
            }
            else {
                var str = '选中' + this.fileList().length + '/10 个文件，共' + this.fileSize().toFixed(2) + 'K,单个文件大小限制:10.00M。';
                this.fileText(str);
            }
        }
    };
    // 上传文件
    HeaderModel.prototype.fileUploadBar = function () {
        var that = this;
        if (that.newFd().length < 1) {
            return window.popBox.show('未选择文件!');
        }
        else {
            this.hiddenBar(true);
            this.hiddenWord(false);
            this.hiddenX(false);
            var xhr_1 = new XMLHttpRequest(); // XMLHttpRequest 对象
            var a_1 = 0;
            var fd = new FormData(); //提交文件
            for (var i = 0; i < that.newFd().length; i++) {
                fd.append("file", that.newFd()[i]);
            }
            fd.append("uid", window.localStorage.getItem('UserId')); //上传者账号
            fd.append("pid", this.saveFolderNameId()); //项目id点击的时候加载进来 this.pid()
            xhr_1.open("post", Configs.Configs.serviceUrl + '/api/ice/upload', true); //post方式，url为服务器请求地址，true 该参数规定请求是否异步处理。
            xhr_1.upload.onprogress = function (ev) {
                //如果ev.lengthComputable为true就可以开始计算上传进度
                //上传进度 = 100* ev.loaded/ev.total
                if (ev.lengthComputable) {
                    var precent = 10 * ev.loaded / ev.total; //更改进度条，及百分比
                    var bar = that.container.querySelector('.file-bar-blue');
                    bar.style.width = precent + '%';
                    var percentText = (100 * ev.loaded / ev.total).toFixed(2);
                    var percentDiv = that.container.querySelector('.file-upload-word');
                    percentDiv.textContent = (Number(percentText) / 2).toFixed(2) + '%';
                    that.progressBar(precent);
                    if (a_1 == 0) {
                        var date1 = new Date(); //开始时间
                        that.stime(date1);
                    }
                    if (precent == 10) {
                        var date2 = new Date(); //结束时间
                        that.etime(date2);
                        var date3 = that.etime().getTime() - that.stime().getTime(); //时间差的毫秒数
                        that.localTime(date3);
                        console.log('本地上传用时' + that.localTime() / 1000 + '----秒');
                        var num = (that.localTime() / 100);
                        var ti = (num / 10);
                        if (ti > 10) {
                            ti = ti / 100;
                        }
                        console.log(ti + '=============diyici');
                        that.progressFunction(num, ti, 400);
                    }
                    a_1++;
                }
            };
            xhr_1.send(fd);
            xhr_1.onreadystatechange = function (ev) {
                //readystate为2表示请求已完成并就绪存有 XMLHttpRequest 的状态。从 0 到 4 发生变化。
                // 0: 请求未初始化
                // 1: 服务器连接已建立
                // 2: 请求已接收
                // 3: 请求处理中
                // 4: 请求已完成，且响应已就绪
                if (ev.currentTarget.readyState == 0) {
                    that.hiddenWan(true);
                    return window.popBox.show('上传失败!');
                }
            };
            xhr_1.onload = function (ev) {
                that.hiddenBar(true);
                that.hiddenWord(false);
                var bar = that.container.querySelector('.file-bar-blue');
                bar.style.width = 25 + '%';
                var percentDiv = that.container.querySelector('.file-upload-word');
                percentDiv.textContent = 100 + '%';
                that.fileData(JSON.parse(xhr_1.response).data);
                if (xhr_1.response) {
                    that.hiddenWan(true);
                    if (JSON.parse(xhr_1.response).status != '0') {
                        // that.hiddenWan(true);
                        return window.popBox.show('上传失败!');
                    }
                    else {
                        return window.popBox.show('上传成功!');
                    }
                }
                console.log(that.fileData());
            };
        }
    };
    // 进度条百分比控制
    HeaderModel.prototype.progressFunction = function (num, ti, n) {
        var _this = this;
        if (num < 0) {
            return; //函数结束条件
        }
        console.log(num + '=========num=======');
        if (num < 3 && Number(this.fileSize().toFixed(2)) < 1024) {
            num = 10;
            n = 200;
        }
        if (num >= 20 && num < 50) {
            num = 20;
            n = 800;
        }
        // 大文件上传处理
        if (num >= 50) {
            num = 60;
            n = 800;
        }
        console.log(this.progressBar() + '=========this.progressBar()=======');
        if (!this.hiddenWan()) {
            var bar = this.container.querySelector('.file-bar-blue');
            if (this.progressBar() < 25) {
                bar.style.width = this.progressBar() + ti + '%';
                var percentDiv = this.container.querySelector('.file-upload-word');
                if (Number(this.progressBar() * 4) + Number(ti) < 100) {
                    percentDiv.textContent = (Number(this.progressBar() * 4) + Number(ti)).toFixed(2) + '%';
                }
                num--;
                this.progressBar(this.progressBar() + ti);
                if (num > 20) {
                    ti = (num / 300);
                }
                else {
                    ti = (num / 20);
                }
                setTimeout(function () {
                    _this.progressFunction(num, ti, n);
                }, n);
            }
        }
    };
    // 删除选中的某个文件
    HeaderModel.prototype.deleteFileUpload = function (r, e) {
        // console.log(e.fileName)
        for (var i = 0; i < this.fileList().length; i++) {
            if (e.fileName == this.fileList()[i].fileName) {
                this.fileList().splice(i, 1);
            }
        }
        this.fileList(this.fileList());
        // console.log(this.fileList())
        var arr1 = this.newFd(); //.getAll('file')
        for (var n = 0; n < this.newFd().length; n++) {
            var file = this.newFd()[n];
            if (e.fileName == file.name) {
                // fd.getAll('file').splice(n,1)
                arr1.splice(n, 1);
                arr1 = arr1;
                this.newFd([]);
                for (var m = 0; m < arr1.length; m++) {
                    this.newFd().push(arr1[m]);
                }
            }
        }
        this.fileSize(0);
        var fl = 0;
        if (this.fileList().length == 0) {
            var str = '选中 0/10 个文件，共0M,单个文件大小限制:10.00M。';
            this.fileText(str);
        }
        // 删除文件后文件数量以及总大小改变
        for (var h = 0; h < this.fileList().length; h++) {
            fl = fl + Number(this.fileList()[h].fileLength);
            this.fileSize(fl / 1024);
            if (this.fileSize() > 1024) {
                this.fileSize(fl / 1048576);
                var str = '选中' + this.fileList().length + '/10 个文件，共' + this.fileSize().toFixed(2) + 'M,单个文件大小限制:10.00M。';
                this.fileText(str);
            }
            else {
                var str = '选中' + this.fileList().length + '/10 个文件，共' + this.fileSize().toFixed(2) + 'K,单个文件大小限制:10.00M。';
                this.fileText(str);
            }
        }
        if (this.fileList().length <= 5) {
            var fs = this.container.querySelector('.file-zs');
            fs.style.height = '30%';
        }
        // console.log(fd.getAll('file'))
    };
    //确定
    HeaderModel.prototype.sureCk = function () {
        // 清空input狂选择的文件
        var obj = this.container.querySelector('.fileUpload-inputOne');
        var obj1 = this.container.querySelector('.fileUpload-inputTwo');
        obj1.value = '';
        obj.value = '';
        var str = '选中 0/10 个文件，共0M,单个文件大小限制:10.00M。';
        this.fileText(str);
        // obj.outerHTML = obj.outerHTML; 
        this.fileData([]);
        this.fileList([]);
        this.hiddenBodyOne(true);
        this.hiddenBodytwo(false);
        this.hiddenWord(true);
        this.hiddenBar(false);
        this.hiddenWan(false);
        // fd.delete('file');
        // fd.delete('pid');
        // fd.delete('uid');
        this.newFd([]);
        // fd.set('file','');
        // fd.set('pid','');
        // fd.set('uid','');
        var bar = this.container.querySelector('.file-bar-blue');
        bar.style.width = '0%';
        var percentDiv = this.container.querySelector('.file-upload-word');
        percentDiv.textContent = '0%';
        var fs = this.container.querySelector('.file-zs');
        fs.style.height = '30%';
        // 更新数据
        this.data = {};
        this.data.fid = this.saveFolderNameId();
        this.data.userId = authorization.getUserId();
        this.loadData();
        if (this.popur4() == 1) {
            this.popur4(0);
        }
        else {
            this.popur4(1);
        }
    };
    // 点击叉号关闭
    HeaderModel.prototype.closeFileUpload = function () {
        // 清空input狂选择的文件
        var obj = this.container.querySelector('.fileUpload-inputOne');
        var obj1 = this.container.querySelector('.fileUpload-inputTwo');
        obj1.value = '';
        obj.value = '';
        var str = '选中 0/10 个文件，共0M,单个文件大小限制:10.00M。';
        this.fileText(str);
        // obj.outerHTML = obj.outerHTML; 
        this.fileData([]);
        this.fileList([]);
        this.hiddenBodyOne(true);
        this.hiddenBodytwo(false);
        this.hiddenWord(true);
        this.hiddenBar(false);
        this.hiddenWan(false);
        this.newFd([]);
        // fd.delete('file');// delete()方法不兼容ie，所以在上传文件后无法进行清空formdata对象操作
        //故采用每次更改上传文件就初始化formdata对象。
        // fd.delete('pid');
        // fd.delete('uid');
        var bar = this.container.querySelector('.file-bar-blue');
        bar.style.width = '0%';
        var percentDiv = this.container.querySelector('.file-upload-word');
        percentDiv.textContent = '0%';
        var fs = this.container.querySelector('.file-zs');
        fs.style.height = '30%';
        // 更新数据
        this.data = {};
        this.data.fid = this.saveFolderNameId();
        this.data.userId = authorization.getUserId();
        this.loadData();
        if (this.popur4() == 1) {
            this.popur4(0);
        }
        else {
            this.popur4(1);
        }
    };
    // unique(arr: any) {
    // 	let emptyObj = {}
    // 	let result = []
    // 	for (let i = 0; i < arr.length; i++) {
    // 		let name = JSON.stringify(arr[i].folderName)
    // 		if (!emptyObj[name]) {
    // 			emptyObj[name] = arr[i].folderName
    // 			result.push(JSON.parse(arr[i]))
    // 		}else{
    // 			let number=(arr[i].folderName as String).charAt((arr[i].folderName as String).length);
    // 			let newNmae;
    // 			if(parseInt(number)!=1){
    // 			}
    // 			result.push(arr[i].folderName=='')
    // 		}
    // 	}
    // 	return result
    // }
    HeaderModel.prototype.loadbubble = function () {
        var arr = [];
        for (var i = 0; i < 7; i++) {
            arr.push(localStorage.getItem(i.toString()));
        }
        return ajax.post('/api/statistics/smessage', { userId: authorization.getUserId(), time: arr }).then(function (d) {
            ko.postbox.publish('leftMenu_myProject', d.data.count0);
            ko.postbox.publish('leftMenu_myFollowProject', d.data.count1);
            ko.postbox.publish('leftMenu_noFollowNews', d.data.count2);
            ko.postbox.publish('leftMenu_waitProjectNews', d.data.count3);
            ko.postbox.publish('leftMenu_signgedProjectNews', d.data.count4);
            ko.postbox.publish('leftMenu_abandonProjectNews', d.data.count5);
            ko.postbox.publish('leftMenu_auditMessage', d.data.count6);
        });
    };
    HeaderModel.prototype.loadnum = function () {
        return ajax.get('/api/statistics/message', { userid: authorization.getUserId(), loginTime: new Date()["Format"]('yyyy-MM-dd hh:mm:ss') }).then(function (d) {
            ko.postbox.publish('leftMenu_allProject', d.data.allProject);
            ko.postbox.publish('leftMenu_followProject', d.data.followProject);
            ko.postbox.publish('leftMenu_nofollow', d.data.nofollow);
            ko.postbox.publish('leftMenu_waitProject', d.data.waitProject);
            ko.postbox.publish('leftMenu_signgedProject', d.data.signgedProject);
            ko.postbox.publish('leftMenu_abandonProject', d.data.abandonProject);
            ko.postbox.publish('leftMenu_noReadProject', d.data.noReadProject);
        });
    };
    HeaderModel.prototype.load = function () {
        this.data.pageIndex = 1;
        return Promise.all([this.loadnum(), this.loadbubble(), this.loadData()]).then(function () { });
    };
    HeaderModel.prototype.onViewModelSetting = function (r) {
        // this.createType(r.data.create);
        // this.deleteType(r.data.delete);
        // this.folders(r.data.folderNames);
        // this.uploadType(r.data.upload);
        // this.saveFolderNameId(r.id);
        // ajax.get('/api/ice/foldermap',{
        // 	fid:r.id
        // }).then(()=>{
        // })
        this.downType(r.data.down);
        return Promise.resolve(false);
    };
    return HeaderModel;
}(KnockoutModel));
var mModel = /** @class */ (function (_super) {
    __extends(mModel, _super);
    function mModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    mModel.prototype.init = function () {
        //console.info('init..............')
        this.hm = new HeaderModel(this.container.querySelector('.Myproject'));
        //this.hm.bind(); 
    };
    mModel.prototype.update = function (arg) {
        var _this = this;
        ajax.post('/api/log/add', { userId: authorization.getUserId(), logMessage: "文件柜" });
        ajax.get("/api/menu/fileSystem", { uid: window.localStorage.getItem("UserId") });
        //this.hm.userAccount(window.localStorage.getItem("UserId"));
        //console.info('updating...........');  /api/ice/foldermap
        this.hm.searchName('');
        //	return this.hm.load();
        return ajax.get("/api/ice/foldermap2", { userId: authorization.getUserId() }).then(function (d) {
            _this.hm.createType(d.data.create);
            _this.hm.deleteType(d.data.delete);
            _this.hm.uploadType(d.data.upload);
            if (d.data.folderNames.length == 0) {
                _this.hm.folders([]);
                _this.hm.data.fid = 'api';
            }
            else {
                _this.hm.folders(d.data.folderNames);
                _this.hm.saveFolderNameId(d.data.folderNames[0].id);
                _this.hm.data.fid = d.data.folderNames[0].id;
            }
            _this.hm.data.userId = authorization.getUserId();
            // this.hm.loadData();
            return _this.hm.load().then(function (d) {
                console.log(_this.hm.viewModel(), '----viewModel---');
                setTimeout(function () {
                    var tr = document.getElementById(_this.hm.saveFolderNameId()); //默认选择
                    tr.setAttribute("style", "background:#cde3f7");
                }, 200);
            });
        });
    };
    mModel.prototype.onInitComplete = function () {
        // var tr = document.getElementById(this.hm.saveFolderNameId());//默认选择
        // tr.setAttribute("style", "background:#cde3f7");
        console.log('---------------------------我来啦哈妮克孜山东省');
    };
    return mModel;
}(Page));
export default mModel;
